const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/idea-management/demands/views/view/$viewId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
export const demandViewSearchSchema = z.object({
  demandId: z.coerce.number().optional(),
  commentId: z.coerce.number().optional(),
  filter: z.enum(['active', 'archived']).optional()
});
export const Route = createFileRoute('/(app)/org/$org/idea-management/demands/views/view/$viewId/')({
  validateSearch: search => demandViewSearchSchema.parse(search),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    topNav: {}
  }
});